<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="props.detailData.platform_abbreviation" width="80%" :open="true" :confirmLoading="state.loading"
        :maskClosable="true" @ok="onFormSubmit" @cancel="
            () => {
                emit('cancel')
            }
        "><a-card :bordered="false">
            <a-table bordered :columns="columns" :loading="state.loading" :data-source="dataSource" rowKey="id"
                size="small">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'name'">
                        {{ record.platform_abbreviation }}<br />
                        <span style="font-size: 12px">{{ record.company_detailed_address }}</span>
                    </template>
                    <template v-else-if="column.dataIndex == 'recommend2'">
                        <span v-if="record.is_provide_adds == 1">
                            {{ text }}
                        </span>
                        <span v-else>不支持</span>
                    </template>
                    <template v-else-if="column.dataIndex == 'recommend3'">
                        <span v-if="record.disposable_switch_gs == 1">
                            {{ text }}
                        </span>
                        <span v-else>不支持</span>
                    </template>
                    <template v-else-if="column.dataIndex == 'price2'">
                        <span v-if="record.is_provide_adds == 1">
                            {{ text }}
                        </span>
                        <span v-else>不支持</span>
                    </template>
                    <template v-else-if="column.dataIndex == 'price3'">
                        <span v-if="record.disposable_switch_gs == 1">
                            {{ text }}
                        </span>
                        <span v-else>不支持</span>
                    </template>
                    <template v-if="column.dataIndex === 'money'">
                        <span v-if="record.money < 0" style="color: red">{{ text }} </span>
                        <span v-else>{{ text }}</span>
                    </template>
                    <template v-if="column.dataIndex === 'doaction'">
                        <a @click="onDelete(record.id)">隐藏</a>
                    </template>
                </template>
            </a-table>
        </a-card>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const emit = defineEmits(['cancel'])
const columns = [
    {
        title: '平台名称',
        dataIndex: 'name',
        className: 'col-text-small'
    },
    {
        title: '注册或迁入包注册价格',
        dataIndex: 'recommend1',
        className: 'col-text-small'
    },
    {
        title: '注册或迁入裸地址价格',
        dataIndex: 'recommend2',
        className: 'col-text-small'
    },
    {
        title: '一次性价格',
        dataIndex: 'recommend3',
        className: 'col-text-small'
    },
    {
        title: '续费价格',
        dataIndex: 'recommend4',
        className: 'col-text-small'
    },
    {
        title: '审核时效',
        dataIndex: 'shenheshixiao',
        className: 'col-text-small'
    },
    {
        title: '特点',
        dataIndex: 'jyfw_gs_onewordtips',
        className: 'col-text-small'
    },
    {
        title: '注册或迁入包注册价格',
        dataIndex: 'price1',
        className: 'col-text-small'
    },
    {
        title: '注册或迁入裸地址价格',
        dataIndex: 'price2',
        className: 'col-text-small'
    },
    {
        title: '一次性拿货价',
        dataIndex: 'price3',
        className: 'col-text-small'
    },
    {
        title: '续费拿货价',
        dataIndex: 'price4',
        className: 'col-text-small'
    },

    {
        title: '操作',
        dataIndex: 'doaction',
        className: 'col-text-small'
    }
]
interface state {
    loading: boolean
    detailData: object
    detailVisible: boolean
}
const state = reactive<state>({
    loading: false,
    detailData: {},
    detailVisible: false
})
let queryParam = reactive<any>({
    remark: ''
})
let dataSource = ref([])
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/platform/detail',
        method: 'post',
        data: { platform_id: props.detailData.id }
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    })
}
const onFormSubmit = () => {
    emit('cancel')
}
const onDelete = (key: string) => {
    dataSource.value = dataSource.value.filter((item) => item.id !== key)
}
</script>
<style lang="less" scoped>
:deep(.col-text-small) {
    font-size: 13px;
}
</style>
